import React from "react";
import { Chip, SxProps, Theme } from "@mui/material";

interface CustomChipProps {
  label: string;
  backgroundColor?: string;
  color?: string;
  borderColor?: string;
  onClick?: () => void;
  size?: "small" | "medium";
  height?: number;
  fontSize?: number | string;
  fontWeight?: number;
  sx?: SxProps<Theme>;
}

const CustomChip: React.FC<CustomChipProps> = ({
  label,
  backgroundColor = "transparent",
  color = "#3E3E3E",
  borderColor,
  onClick,
  size = "small",
  height,
  fontSize = "12px",
  fontWeight = 600,
  sx,
}) => {
  return (
    <Chip
      label={label}
      size={size}
      onClick={onClick}
      sx={{
        backgroundColor,
        color,
        fontWeight,
        fontSize,
        ...(borderColor && { border: `1px solid ${borderColor}` }),
        ...(height !== undefined && { height }),
        ...(onClick && { cursor: "pointer" }),
        "&:hover": { backgroundColor },
        ...sx,
      }}
    />
  );
};

export default CustomChip;
